import React, { useEffect } from 'react'
import { AiOutlineHeart, AiOutlineWhatsApp, AiOutlineInstagram, AiOutlineCar } from 'react-icons/ai'
import { GrFacebookOption } from 'react-icons/gr'
import { RiPhoneFill } from 'react-icons/ri'
import AOS from 'aos'
import 'aos/dist/aos.css'

const Social = ({
  businessName,
  businessDescription,
  phoneNumber,
  email,
  facebookUrl,
  instagram,
  whatsapp,
  wazeUrl,
  domainUrl,
}) => {
  const iconsColor = '#3d3936'

  const instagramUrl = `https://www.instagram.com/${instagram}`
  const recommendUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    domainUrl,
  )}&quote=כרטיס ביקור דיגיטלי`

  // Function to generate and save the contact
  const saveContact = () => {
    const contact = {
      firstName: businessName,
      lastName: businessDescription,
      phoneNumber: phoneNumber,
      email: email,
    }

    // Create the vCard content
    const vCardContent = `BEGIN:VCARD
VERSION:3.0
N:${contact.lastName};${contact.firstName};;;
FN:${contact.firstName} ${contact.lastName}
TEL;TYPE=CELL:${contact.phoneNumber}
EMAIL:${contact.email}
END:VCARD`

    // Create a new Blob with the vCard content
    const blob = new Blob([vCardContent], { type: 'text/vcard' })

    // Create a temporary download link
    const downloadLink = document.createElement('a')
    downloadLink.href = URL.createObjectURL(blob)
    downloadLink.download = 'contact.vcf'

    // Simulate a click on the download link to trigger the download
    downloadLink.click()

    // Clean up the temporary download link
    URL.revokeObjectURL(downloadLink.href)
    downloadLink.remove()
  }

  return (
    <div>
      <div className="w-full flex flex-col mt-4 lg:flex-row" data-aos="fade-zoom-in" data-aos-easing="linear">
        <div className="w-full lg:w-[50%] flex justify-around mx-auto">
          <a
            href={`tel:${phoneNumber}`}
            target="_blank"
            className="flex flex-col justify-center items-center w-[100px] h-[100px]"
          >
            <div className="group flex items-center justify-center w-11 h-11 rounded-full border-[1px] border-ring bg-gradient-to-l from-mainRing to-secondaryRing hover:scale-[110%] duration-200">
              <div className="group-hover:scale-[110%]">
                <RiPhoneFill size={25} className="text-icons" />
              </div>
            </div>
            <p className="mt-1 font-medium text-main">חייגו אליי</p>
          </a>
          <a
            href={`https://wa.me/${whatsapp}`}
            target="_blank"
            className="flex flex-col justify-center items-center w-[100px] h-[100px]"
          >
            <div className="group flex items-center justify-center w-11 h-11 rounded-full border-[1px] border-ring bg-gradient-to-l from-mainRing to-secondaryRing hover:scale-[110%] duration-200">
              <div className="group-hover:scale-[110%]">
                <AiOutlineWhatsApp size={25} className="text-icons" />
              </div>
            </div>
            <p className="mt-1 font-medium text-main">ווטסאפ</p>
          </a>

          <a
            href={recommendUrl}
            target="_blank"
            className="flex flex-col justify-center items-center w-[100px] h-[100px]"
          >
            <div className="group flex items-center justify-center w-11 h-11 rounded-full border-[1px] border-ring bg-gradient-to-l from-mainRing to-secondaryRing hover:scale-[110%] duration-200">
              <div className="group-hover:scale-[110%]">
                <AiOutlineHeart size={25} className="text-icons" />
              </div>
            </div>
            <p className="mt-1 font-medium text-main">המליצו עליי</p>
          </a>
        </div>
        <div className="w-full lg:w-[50%] flex justify-around mx-auto">
          <a href={wazeUrl} target="_blank" className=" flex flex-col justify-center items-center w-[100px] h-[100px]">
            <div className="group flex items-center justify-center w-11 h-11  rounded-full border-[1px] border-ring bg-gradient-to-l from-mainRing to-secondaryRing hover:scale-[110%] duration-200">
              <div className="group-hover:scale-[110%]">
                <AiOutlineCar size={25} className="text-icons" />
              </div>
            </div>
            <p className="mt-1 font-medium text-main text-center">נווטו לקליניקה</p>
          </a>

          <a
            href={instagramUrl}
            target="_blank"
            className="flex flex-col justify-center items-center w-[100px] h-[100px]"
          >
            <div className="group flex items-center justify-center w-11 h-11 rounded-full border-[1px] border-ring bg-gradient-to-l from-mainRing to-secondaryRing hover:scale-[110%] duration-200">
              <div className="group-hover:scale-[110%]">
                <AiOutlineInstagram size={25} className="text-icons" />
              </div>
            </div>
            <p className="mt-1 font-medium text-main">אינסטגרם</p>
          </a>

          <a
            href={facebookUrl}
            target="_blank"
            className="flex flex-col justify-center items-center w-[100px] h-[100px]"
          >
            <div className="group flex items-center justify-center w-11 h-11 rounded-full border-[1px] border-ring bg-gradient-to-l from-mainRing to-secondaryRing hover:scale-[110%] duration-200">
              <div className="group-hover:scale-[110%]">
                <GrFacebookOption size={25} className="text-icons" />
              </div>
            </div>
            <p className="mt-1 font-medium text-main">פייסבוק</p>
          </a>
        </div>
      </div>

      <div data-aos="fade-zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="800">
        <button
          className="mt-4 mx-auto rounded-full flex items-center border-4 bg-gradient-to-l from-mainSave to-secondarySave text-textSave px-7 border-borderSave hover:opacity-95 hover:scale-[108%] duration-300 shadow-lg"
          onClick={saveContact}
        >
          <span className="pr-1.5 mb-2 text-4xl font-medium">+</span>
          <span className="pr-1.5 text-lg mb-1 font-medium">שמרו אותי באנשי הקשר</span>
        </button>
        <a
          target="_blank"
          href="https://devorahslaneprices.netlify.app/"
          className="mt-4 mx-auto rounded-full flex items-center border-4 w-64 p-2 bg-gradient-to-l text-center from-textSave to-textSave text-mainSave px-7 border-mainSave hover:opacity-95 hover:scale-[108%] duration-300 shadow-lg"
        >
          <span dir="rtl" className="pr-1.5 text-lg mb-1 font-semibold">
            לחצו כאן כדי לצפות במחירון המלא
          </span>
        </a>
      </div>
    </div>
  )
}

export default Social
